export class Websocket {
  constructor() {
    this.socket = window.Echo;
  }

  connectParticipant(id, callback = () => {}) {
    if (!id) throw "Participant Id is empty";

    this.socket
      .private(`participants.${id}`)
      .listen(".App\\Events\\CarPassStatusUpdated", callback)
      .listen(".App\\Events\\CarPassBarcodeUpdated", callback)
      .listen(".App\\Events\\PersonalPassStatusUpdated", callback)
      .listen(".App\\Events\\AdditionalOrderStatusUpdated", callback)
      .listen(".App\\Events\\CatalogOrderStatusUpdated", callback);
  }

  disconnectParticipant(id) {
    this.socket.leave(`participants.${id}`);
  }

  connectParticipantChat(id, callback = () => {}) {
    if (!id) throw "Participant Id is empty";

    this.socket
      .private(`participants.${id}`)
      .listen(".App\\Events\\AdditionalOrderMessageCreated", callback);
  }

  disconnectParticipantChat(id) {
    this.socket.leave(`participants.${id}`);
  }

  connectUser(id, callback = () => {}) {
    this.socket
      .private(`App.Models.User.${id}`)
      .listen(".App\\Events\\NotificationCreated", callback);
  }

  disconnectUser(id) {
    this.socket.leave(`App.Models.User.${id}`);
  }
}
